import { StatusBar, StatusBarStyle } from 'expo-status-bar'
import { observer } from 'mobx-react-lite'
import React, { useState } from 'react'
import {
  ActivityIndicator,
  KeyboardAvoidingView,
  Platform,
  SafeAreaView,
  TextInput,
  TouchableOpacity,
  View
} from 'react-native'
import { useFocusEffect, useLocalSearchParams, useRouter } from 'expo-router'

import { Text } from '../../components'
import { MainHeader } from '../../components/MainHeader/MainHeader'
import { translate } from '../../i18n/translate'
import { useStore } from '../../models'
import { EditableFields } from './EditProfileSheet'
import { styles } from './styles'

export const OtpEmailVerification = observer(() => {
  const router = useRouter()
  const store = useStore()
  const { updatedEmail } = useLocalSearchParams<{ updatedEmail: EditableFields }>()

  const [emailOtp, SetEmailOtp] = useState('')
  const [otpError, setOtpError] = useState('')

  const [isLoading, setIsLoading] = useState(false)
  const placeholder = translate('profileScreen.placeholder')

  useFocusEffect(
    React.useCallback(() => {
      SetEmailOtp('')
      setOtpError('')
    }, [])
  )

  const goBack = () => {
    router.navigate('/edit-profile')
  }

  const onSubmit = async () => {
    const name = store.session.user?.name
    try {
      setIsLoading(true)
      if (emailOtp) {
        await store.session.verifyUserEmail(emailOtp, updatedEmail)
        await store.session.updateUserData(name, updatedEmail)
        setIsLoading(false)
        router.replace('/profile')
      }
    } catch (error) {
      // @ts-ignore
      setOtpError(error?.response?.errors[0]?.message)
      setIsLoading(false)
    }
  }

  return (
    <SafeAreaView style={styles.container}>
      <StatusBar animated={true} style={'dark' as StatusBarStyle} hidden={false} />
      <MainHeader leftPress={goBack} title={'Verify Email'} titleStyle={{ color: '#121212' }} />
      <KeyboardAvoidingView
        keyboardVerticalOffset={Platform.OS === 'ios' ? 0 : 50}
        behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
        style={{ flex: 1 }}
      >
        <View style={{ flex: 1, paddingHorizontal: 24 }}>
          <Text tx={'profileScreen.emailVerification'} style={styles.question} />
          <Text style={styles.email}>({updatedEmail})</Text>
          <Text tx={'profileScreen.verificationCode'} style={styles.nameText} />
          <TextInput
            placeholder={placeholder}
            placeholderTextColor={'#68706D'}
            style={styles.inputField}
            allowFontScaling={false}
            autoCorrect={false}
            maxLength={6}
            autoComplete="off"
            autoCapitalize="none"
            value={emailOtp}
            onChangeText={(value: string) => {
              SetEmailOtp(value)
            }}
            autoFocus={true}
          />
          {otpError ? <Text style={styles.error}>{otpError}</Text> : null}
          <TouchableOpacity
            disabled={emailOtp === '' || emailOtp.length < 6}
            onPress={onSubmit}
            style={[styles.buttonStyle, { opacity: emailOtp === '' || emailOtp.length < 6 ? 0.5 : 1 }]}
          >
            <View style={styles.buttonView}>
              <Text tx={'common.done'} style={styles.buttonText} />
              {isLoading ? <ActivityIndicator size="small" color="#FFFFFF" style={styles.loadingStyle} /> : null}
            </View>
          </TouchableOpacity>
        </View>
      </KeyboardAvoidingView>
    </SafeAreaView>
  )
})
